import { saveAs } from 'file-saver';
import * as ExcelJS from 'exceljs';

export async function generateExcel(
  data: {
    content: any[];
    total?: any;
  } | null,
  columns: any[],
  fileName: string,
) {
  if (!data?.content || data.content.length === 0) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Reports');

  const headers = [
    '№',
    ...columns.map((col) =>
      typeof col.header === 'function' ? col.header() : String(col.header),
    ),
  ];

  worksheet.addRow(headers);

  const headerRow = worksheet.getRow(1);
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE9E9E9' },
    };
    cell.font = { bold: true };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  if (data.content.length > 0 && data.total) {
    const totalsRowData = ['Jami'];

    columns.forEach((col) => {
      const accessorKey = col.accessorKey;
      if (data.total && accessorKey in data.total) {
        const totalValue = data.total[accessorKey];
        totalsRowData.push(
          totalValue !== null ? totalValue.toLocaleString() : '',
        );
      } else {
        totalsRowData.push('');
      }
    });

    const totalsRow = worksheet.addRow(totalsRowData);

    totalsRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF5F5F5' },
      };
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  }

  data.content.forEach((row, index) => {
    const rowData = [index + 1];

    columns.forEach((col) => {
      let value: any;

      if (col.cell && typeof col.cell === 'function') {
        value = col.cell({ row: { original: row } });
      } else {
        value = row[col.accessorKey];
      }

      rowData.push(value ?? '');
    });

    const dataRow = worksheet.addRow(rowData);

    dataRow.eachCell((cell) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };

      const cellNumber = cell.address.substring(0, 1);
      if (cellNumber === 'A') {
        cell.alignment = { horizontal: 'center' };
      }
    });
  });

  worksheet.columns.forEach((column) => {
    if (column) {
      let maxLength = 0;
      if (column.eachCell) {
        column.eachCell({ includeEmpty: true }, (cell) => {
          const columnLength = cell.value ? String(cell.value).length : 10;
          if (columnLength > maxLength) {
            maxLength = columnLength;
          }
        });
        column.width = maxLength + 2;
      }
    }
  });

  for (let i = 1; i <= worksheet.rowCount; i++) {
    const row = worksheet.getRow(i);
    row.getCell(1).alignment = { horizontal: 'center' };
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  saveAs(blob, `${fileName}.xlsx`);
}
